import * as React from "react";
const FoodAndNutritionSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="rgba(238, 65, 55, 1)"
      d="M21 9.75h-.785a8.25 8.25 0 0 0-16.43 0H3a.75.75 0 0 0-.75.75 9.783 9.783 0 0 0 5.25 8.651v.349A1.5 1.5 0 0 0 9 21h6a1.5 1.5 0 0 0 1.5-1.5v-.349a9.782 9.782 0 0 0 5.25-8.651.75.75 0 0 0-.75-.75Zm-2.293 0h-4.82a6.735 6.735 0 0 1 3.868-2.772c.518.842.843 1.789.952 2.772Zm-2.443-4.478c.172.14.336.289.494.445a8.243 8.243 0 0 0-4.608 4.031H9.384A6.774 6.774 0 0 1 15.75 5.25c.172 0 .343.008.514.022ZM12 3.75c.602 0 1.2.082 1.781.24a8.284 8.284 0 0 0-5.969 5.76H5.293a6.758 6.758 0 0 1 6.707-6ZM15.437 18a.75.75 0 0 0-.437.684v.816H9v-.816A.75.75 0 0 0 8.563 18a8.277 8.277 0 0 1-4.781-6.75h16.433A8.278 8.278 0 0 1 15.437 18Z"
    />
  </svg>
);
export default FoodAndNutritionSVG;
